<template>
  <v-snackbar v-model="showSnackbar" color="warning" :timeout="6000" bottom>
    Este menu está temporariamente indisponível.
    <template v-slot:action="{ attrs }">
      <v-btn text v-bind="attrs" @click="showSnackbar = false">Fechar</v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { eventBus } from '../../../components/js/eventBus.js'

export default {
  name: 'MenuAccessBlockWatcher',
  data: () => ({
    showSnackbar: false,
  }),
  computed: {
    ...mapGetters('auth', ['hasToken', 'hasAcesso']),
  },
  watch: {
    hasToken(now, before) {
      if (!(now && !before)) return
      if (this.hasAcesso) {
        this.ActionCheckBlockedRoutes()
        this.ActionStartBlockPolling()
      }
    },
    hasAcesso(now, before) {
      // Dispara assim que a instituição/período são selecionados — antes
      // disso o endpoint responde 401 (ver ActionCheckBlockedRoutes).
      if (now && !before) {
        this.ActionCheckBlockedRoutes()
        this.ActionStartBlockPolling()
      } else if (!now && before) {
        this.ActionStopBlockPolling()
      }
    },
    '$route.path'() {
      if (this.hasToken && this.hasAcesso) this.ActionCheckBlockedRoutes()
    },
  },
  mounted() {
    if (this.hasToken && this.hasAcesso) {
      this.ActionCheckBlockedRoutes()
      this.ActionStartBlockPolling()
    }
    eventBus.$on('menu-access-block:blocked-nav-attempt', this.onBlockedNavAttempt)
  },
  beforeDestroy() {
    this.ActionStopBlockPolling()
    eventBus.$off('menu-access-block:blocked-nav-attempt', this.onBlockedNavAttempt)
  },
  methods: {
    ...mapActions('menuAccessBlock', [
      'ActionCheckBlockedRoutes',
      'ActionStartBlockPolling',
      'ActionStopBlockPolling',
    ]),
    onBlockedNavAttempt() {
      this.showSnackbar = true
    },
  },
}
</script>
